import '../plugins/jquery.js'

class WindowInfo{
	#size = {
		w: 0,
		h: 0,
		vw: 0,
		vh: 0,
	}
	#sc = {
		top: 0,
		bottom: 0,
		left: 0
	}

	constructor() {
		this.update();

		$(window).on('load', () =>{
			this.update();
		});
		$(window).on('resize', () =>{
			this.updateSize()
		});
		$(window).on('scroll', () => {
			this.updateScroll()
		});
	}

	update(){
		this.updateScroll();
		this.updateSize();
	}

	// スクロール情報をアップデート
	updateScroll() {
		this.#sc.top = $(window).scrollTop();
		this.#sc.bottom = this.#sc.top + this.#size.h;
		this.#sc.left = $(window).scrollLeft();
	}

	// サイズ情報をアップデート
	updateSize() {
		this.#size.w = $(window).innerWidth();
		this.#size.h = $(window).innerHeight();
		$('html').css({
			'--vh': `${this.#size.w * 0.01}px`,
			'--vw': `${this.#size.h * 0.01}px`,
		})
	}

	get sc(){
		return this.#sc
	}

	get size(){
		return this.#size
	}
}

/**
ウィンドウのサイズとかスクロールとかの情報をまとめたやつ<br/>importするだけで使える
@name windowInfo
@prop {Object} sc ウィンドウスクロール関係の数値
@prop {Number} sc.top top
@prop {Number} sc.bottom bottom
@prop {Number} sc.left left
@prop {Object} size ウィンドウサイズ関係の数値
@prop {Number} size.w 幅（px）
@prop {Number} size.h 高さ（px）
@prop {Function} update スクロール情報とサイズ情報をアップデート
@prop {Function} updateScroll スクロール情報をアップデート
@prop {Function} updateSize サイズ情報をアップデート

@example <caption>JS</caption>
import '/assets/js/modules/window_info.js';
 */
window.windowInfo = new WindowInfo();
